<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">To all the team at Austin Macauley Publishers; thank you.</p>
<br/>
<p style="text-align: center;">To all the guys who have encouraged and supported me in the writing of this book, and you all know who you are: thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?8af3425c